import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function USCFilmsIOS() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">USC Films iOS App</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={1}>
              This native SwiftUI application allows users to view some of the
              trending Movies and TV shows, search for movies and TV shows of
              their choice and view their details. There’s also a watchlist
              where users can save, remove and track the TV shows and movies
              they would like to watch later.
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              Swift, SwiftUI, Alamofire, SwiftyJSON, Kingfisher, CocaPods, XCode
            </Box>

            <Box mt={4} className="title">
              Demo (Normal)
            </Box>
            <Box mt={2}>
              <Grid container>
                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/0_home_movies.jpg"
                    alt="Home Screen: Movies"
                  />
                  <Box className="mobileDescription">Home Screen: Movies</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/1_home_tvs.jpg"
                    alt="Home Screen: TV Shows"
                  />
                  <Box className="mobileDescription">Home Screen: TV Shows</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/2_details_1.jpg"
                    alt="Movie Details (part 1)"
                  />
                  <Box className="mobileDescription">
                    Movie Details (part 1)
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/3_details_2.jpg"
                    alt="Movie Details (part 2)"
                  />
                  <Box className="mobileDescription">
                    Movie Details (part 2)
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/4_review.jpg"
                    alt="Movie Reviews"
                  />
                  <Box className="mobileDescription">Movie Reviews</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/5_search.jpg"
                    alt="Search Screen"
                  />
                  <Box className="mobileDescription">Search Screen</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/6_watchlist.jpg"
                    alt="Watchlist Screen"
                  />
                  <Box className="mobileDescription">Watchlist Screen</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/7_dragable.jpg"
                    alt="Drag Gesture"
                  />
                  <Box className="mobileDescription">Drag Gesture</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/8_long_press.jpg"
                    alt="Long Press Gesture"
                  />
                  <Box className="mobileDescription">Long Press Gesture</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/light/9_toast.jpg"
                    alt="Toast Micro-interaction"
                  />
                  <Box className="mobileDescription">
                    Toast Micro-interaction
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box mt={4} className="title">
              Demo (Dark Mode)
            </Box>
            <Box mt={2}>
              <Grid container>
                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/0_home_movies.jpg"
                    alt="Home Screen: Movies"
                  />
                  <Box className="mobileDescription">Home Screen: Movies</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/1_home_tvs.jpg"
                    alt="Home Screen: TV Shows"
                  />
                  <Box className="mobileDescription">Home Screen: TV Shows</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/2_details_1.jpg"
                    alt="Movie Details (part 1)"
                  />
                  <Box className="mobileDescription">
                    Movie Details (part 1)
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/3_details_2.jpg"
                    alt="Movie Details (part 2)"
                  />
                  <Box className="mobileDescription">
                    Movie Details (part 2)
                  </Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/4_review.jpg"
                    alt="Movie Reviews"
                  />
                  <Box className="mobileDescription">Movie Reviews</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/5_search.jpg"
                    alt="Search Screen"
                  />
                  <Box className="mobileDescription">Search Screen</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/6_watchlist.jpg"
                    alt="Watchlist Screen"
                  />
                  <Box className="mobileDescription">Watchlist Screen</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/7_dragable.jpg"
                    alt="Drag Gesture"
                  />
                  <Box className="mobileDescription">Drag Gesture</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/8_long_press.jpg"
                    alt="Long Press Gesture"
                  />
                  <Box className="mobileDescription">Long Press Gesture</Box>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <img
                    className="mobileFrame"
                    src="https://raw.githubusercontent.com/shen92/shen92.github.io/main/images/USCFilms/ios/dark/9_toast.jpg"
                    alt="Toast Micro-interaction"
                  />
                  <Box className="mobileDescription">
                    Toast Micro-interaction
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default USCFilmsIOS;
